var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v("This Week's Deadline " + _vm._s(_vm.isSubtask ? 'Subtasks' : 'Tasks'))]), _c('b-card-text', [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table table-custom-style striped",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$row2, _props$row3, _props$row3$phase, _props$row3$phase$dat, _props$row4, _props$row4$phase, _props$row4$phase$dat, _props$row5, _props$row6, _props$column2, _props$row7, _props$row8, _props$row10, _props$column3, _props$row11, _props$row11$phase, _props$row11$phase$da, _props$column4, _props$row12, _props$row12$mileston, _props$row12$mileston2, _props$row12$mileston3, _props$column5, _props$row13, _props$row14, _props$row15, _props$row16, _props$row17, _props$row18;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_tasks' ? [_c('span', [props !== null && props !== void 0 && (_props$row = props.row) !== null && _props$row !== void 0 && _props$row.overdue ? _c('b-badge', {
          attrs: {
            "variant": "light-danger"
          }
        }, [_vm._v(" Overdue ")]) : _vm._e(), _c('b-link', {
          attrs: {
            "href": _vm.getPageUrl(props === null || props === void 0 ? void 0 : props.row)
          }
        }, [_c('div', {
          staticClass: "font-weight-bold",
          staticStyle: {
            "color": "black"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.breakTitle(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.title))
          }
        })])], 1), _c('div', [_vm._v(" Phase: "), props !== null && props !== void 0 && (_props$row3 = props.row) !== null && _props$row3 !== void 0 && (_props$row3$phase = _props$row3.phase) !== null && _props$row3$phase !== void 0 && (_props$row3$phase$dat = _props$row3$phase.data) !== null && _props$row3$phase$dat !== void 0 && _props$row3$phase$dat.title ? [_c('b-badge', {
          attrs: {
            "variant": "light-primary"
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : (_props$row4$phase = _props$row4.phase) === null || _props$row4$phase === void 0 ? void 0 : (_props$row4$phase$dat = _props$row4$phase.data) === null || _props$row4$phase$dat === void 0 ? void 0 : _props$row4$phase$dat.title) + " ")])] : _c('b-badge', {
          attrs: {
            "variant": "light-danger",
            "pill": ""
          }
        }, [_vm._v(" N / A ")])], 2), _c('div', [props !== null && props !== void 0 && (_props$row5 = props.row) !== null && _props$row5 !== void 0 && _props$row5.word_count ? [_vm._v(" Word Count: "), _c('b-badge', {
          attrs: {
            "variant": "light-info"
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : _props$row6.word_count) + " ")])] : _vm._e()], 2)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_member_info' ? [_vm._l(props.row.team.data, function (member, index) {
          return _c('span', {
            key: index
          }, [index <= 2 ? [_c('b-avatar', {
            staticStyle: {
              "margin": "1px"
            },
            attrs: {
              "src": (member === null || member === void 0 ? void 0 : member.avatar) === '' ? '/avatar.svg' : member === null || member === void 0 ? void 0 : member.avatar,
              "size": "26"
            }
          })] : _vm._e()], 2);
        }), (props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.team_count) > 0 ? _c('span', [(props === null || props === void 0 ? void 0 : (_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : _props$row8.team_count) > 3 ? _c('span', [_c('b-link', {
          on: {
            "click": function click($event) {
              var _props$row9, _props$row9$team;
              return _vm.showAllAddedMemberModal(props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : (_props$row9$team = _props$row9.team) === null || _props$row9$team === void 0 ? void 0 : _props$row9$team.data);
            }
          }
        }, [_vm._v(" + " + _vm._s((props === null || props === void 0 ? void 0 : (_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : _props$row10.team_count) - 3) + " more ")])], 1) : _vm._e()]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" N / A ")])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_phase_info' ? [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : (_props$row11$phase = _props$row11.phase) === null || _props$row11$phase === void 0 ? void 0 : (_props$row11$phase$da = _props$row11$phase.data) === null || _props$row11$phase$da === void 0 ? void 0 : _props$row11$phase$da.title) + " ")])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_supervisor' ? [_c('UserCard', {
          attrs: {
            "user": props === null || props === void 0 ? void 0 : (_props$row12 = props.row) === null || _props$row12 === void 0 ? void 0 : (_props$row12$mileston = _props$row12.milestoneTaskBoard) === null || _props$row12$mileston === void 0 ? void 0 : (_props$row12$mileston2 = _props$row12$mileston.data) === null || _props$row12$mileston2 === void 0 ? void 0 : (_props$row12$mileston3 = _props$row12$mileston2.supervisor) === null || _props$row12$mileston3 === void 0 ? void 0 : _props$row12$mileston3.data
          }
        })] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column5 = props.column) === null || _props$column5 === void 0 ? void 0 : _props$column5.field) === 'format_date' ? [_c('b', [_vm._v("Deadline: ")]), props !== null && props !== void 0 && (_props$row13 = props.row) !== null && _props$row13 !== void 0 && _props$row13.deadline ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(props === null || props === void 0 ? void 0 : (_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : _props$row14.deadline)) + " ")]) : _c('span', [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(" N/A ")])], 1), _c('br'), _c('b', [_vm._v("Actual Start Date: ")]), props !== null && props !== void 0 && (_props$row15 = props.row) !== null && _props$row15 !== void 0 && _props$row15.actual_start_date ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(props === null || props === void 0 ? void 0 : (_props$row16 = props.row) === null || _props$row16 === void 0 ? void 0 : _props$row16.actual_start_date)) + " ")]) : _c('span', [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(" N/A ")])], 1), _c('br'), _c('b', [_vm._v("Actual End Date: ")]), props !== null && props !== void 0 && (_props$row17 = props.row) !== null && _props$row17 !== void 0 && _props$row17.actual_end_date ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(props === null || props === void 0 ? void 0 : (_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : _props$row18.actual_end_date)) + " ")]) : _c('span', [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(" N/A ")])], 1)] : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['3', '10', '20', '50']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }